const ESIZ_KOLEKSIYON_IMG =
  'https://kiyafet-magazasi-backend.vercel.app/api/resim/img_1786711279376_wujgfr4f';

export function BannerSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="relative overflow-hidden rounded-lg h-80 group">
        <img
          src={ESIZ_KOLEKSIYON_IMG}
          alt="Eşsiz Koleksiyonlar"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-pink-900/70 to-transparent flex flex-col justify-center px-8 text-white">
          <h3 className="text-3xl font-bold mb-2">Eşsiz Koleksiyonlar</h3>
          <p className="text-lg mb-4">İndirimde %40'a Varan Fırsatlar</p>
          <a
            href="#products-section"
            className="bg-white text-pink-600 px-6 py-2 rounded-full font-semibold inline-flex items-center justify-center w-fit hover:bg-pink-50 transition-colors"
          >
            Şimdi Alışveriş Yap
          </a>
        </div>
      </div>
    </section>
  );
}
